<template>
	<footer role="contentinfo">
		<div>
			<img src="~/assets/media/i/logo-footer.webp" alt="Mailuft Logo" width="93" height="90" />
			<ul role="navigation">
				<li v-for="(link, key) in links" :class="{ 'active': $route.path === link.to }">
					<NuxtLink :to="link.to" :key="key">{{ link.name }}</NuxtLink>
				</li>
			</ul>
			<span>&copy; 2016 - {{ new Date().getFullYear() }} &mdash; {{ $config.public.company.name }}</span>
		</div>
	</footer>
</template>

<script setup lang="ts">
defineProps<{links: Array<{to: string, name: string}>}>()
</script>

<style lang="css" scoped>
footer
{
	background-color: rgb(var(--black));
}

footer > div
{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	margin: 0 auto;
	padding: 0 2rem;
	box-sizing: border-box;
	max-width: 500px;
	min-height: 350px;
}

div > img
{
	display: block;
	width: auto;
	height: 90px;
	margin-bottom: 2rem;
}

div > ul
{
	display: flex;
	justify-content: center;
	list-style: none;
	border-bottom: 1px solid rgba(var(--white),.2);
	margin: 0 0 1rem;
	padding: 0 0 1rem;
	width: 100%;
	gap: 1.25rem;
}

div > ul > li
{
	flex: 0;
}

div > ul a
{
	color: rgb(var(--white));
	opacity: .6;
	text-decoration: none;
	transition: opacity .4s ease;
}

div > ul li.active a,
div > ul a:hover
{
	opacity: 1;
}

div > span
{
	display: block;
	text-align: center;
	opacity: .3;
	font-weight: 300;
}
</style>